/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AddConsentGenerated } from '../models/add-consent-generated';
import { ConsentGenerated } from '../models/consent-generated';

@Injectable({
  providedIn: 'root',
})
export class ConsentServiceGenerated extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation postConsent
   */
  static readonly PostConsentPath = '/consent';

  /**
   * Add consent.
   *
   * Add consent
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postConsent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postConsent$Response(params?: {
    context?: HttpContext
    body?: AddConsentGenerated
  }
): Observable<StrictHttpResponse<ConsentGenerated>> {

    const rb = new RequestBuilder(this.rootUrl, ConsentServiceGenerated.PostConsentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConsentGenerated>;
      })
    );
  }

  /**
   * Add consent.
   *
   * Add consent
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `postConsent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postConsent(params?: {
    context?: HttpContext
    body?: AddConsentGenerated
  }
): Observable<ConsentGenerated> {

    return this.postConsent$Response(params).pipe(
      map((r: StrictHttpResponse<ConsentGenerated>) => r.body as ConsentGenerated)
    );
  }

  /**
   * Path part for operation getConsentConsentType
   */
  static readonly GetConsentConsentTypePath = '/consent/{consentId}';

  /**
   * Get consent.
   *
   * Get consent
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsentConsentType()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsentConsentType$Response(params: {
    consentId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ConsentGenerated>> {

    const rb = new RequestBuilder(this.rootUrl, ConsentServiceGenerated.GetConsentConsentTypePath, 'get');
    if (params) {
      rb.path('consentId', params.consentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConsentGenerated>;
      })
    );
  }

  /**
   * Get consent.
   *
   * Get consent
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getConsentConsentType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsentConsentType(params: {
    consentId: string;
    context?: HttpContext
  }
): Observable<ConsentGenerated> {

    return this.getConsentConsentType$Response(params).pipe(
      map((r: StrictHttpResponse<ConsentGenerated>) => r.body as ConsentGenerated)
    );
  }

  /**
   * Path part for operation deleteConsentConsentType
   */
  static readonly DeleteConsentConsentTypePath = '/consent/{consentId}';

  /**
   * Delete consent.
   *
   * Delete consent
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteConsentConsentType()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteConsentConsentType$Response(params: {
    consentId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ConsentServiceGenerated.DeleteConsentConsentTypePath, 'delete');
    if (params) {
      rb.path('consentId', params.consentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete consent.
   *
   * Delete consent
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteConsentConsentType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteConsentConsentType(params: {
    consentId: string;
    context?: HttpContext
  }
): Observable<void> {

    return this.deleteConsentConsentType$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
